import { mutateApi } from "../../../utils/api/ApiMethods"

export const updatePayment = (paymentMethodId, data) => {
  return mutateApi({
    url: `/account/payment/${paymentMethodId}`,
    method: "PATCH",
    data: data,
  })
}
